// WALDSCHUTZPROJEKTE - GARANTIERTE DATEN
// Diese Projekte werden IMMER angezeigt, unabhängig vom Backend-Status

export const FOREST_PROJECTS = [
  {
    id: "1",
    name: "Schweiz",
    location: "Alpen Region",
    size: "2'100 Hektar",
    status: "Aktiv",
    description: "Schutz alpiner Bergwälder und Wiesen in den Schweizer Alpen. Lebensraum für Steinböcke, Murmeltiere, Adler und seltene Alpenblumen.",
    image: "https://images.unsplash.com/photo-1721102163247-70da290dfde5?crop=entropy&cs=srgb&fm=jpg&q=85",
    raised: 11000.0,
    goal: 100000.0
  },
  {
    id: "2",
    name: "Österreich",
    location: "Alpen & Waldviertel",
    size: "1'500 Hektar",
    status: "Aktiv",
    description: "Schutz österreichischer Bergwälder und Mischwälder im Waldviertel. Lebensraum für Rothirsche, Luchse, Auerhähne und seltene Orchideen.",
    image: "https://images.unsplash.com/photo-1516550893923-42d28e5677af?crop=entropy&cs=srgb&fm=jpg&q=85",
    raised: 8500.0,
    goal: 90000.0
  },
  {
    id: "3",
    name: "Deutschland",
    location: "Schwarzwald Region",
    size: "1'800 Hektar",
    status: "Aktiv",
    description: "Schutz deutscher Mischwälder im Schwarzwald. Lebensraum für Rehe, Wildschweine, Füchse, Eulen und eine vielfältige Pflanzenwelt.",
    image: "https://images.unsplash.com/photo-1595198526495-e43a42f84558?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxzY2h3YXJ6d2FsZHxlbnwwfHx8fDE3NjM0NTkwMDV8MA&ixlib=rb-4.1.0&q=85",
    raised: 2000.0,
    goal: 100000.0
  },
  {
    id: "4",
    name: "Südosteuropa",
    location: "Balkanländer",
    size: "2'800 Hektar",
    status: "Aktiv",
    description: "Schutz der letzten Urwälder Europas in den Balkanländern. Lebensraum für Braunbären, Wölfe, Wildkatzen und seltene Greifvögel.",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?crop=entropy&cs=srgb&fm=jpg&q=85",
    raised: 6200.0,
    goal: 85000.0
  },
  {
    id: "5",
    name: "Afrika",
    location: "Verschiedene Länder",
    size: "4'100 Hektar",
    status: "Aktiv",
    description: "Schutz afrikanischer Savannen-Wälder - Lebensraum für Elefanten, Giraffen, Zebras, Löwen und eine einzigartige Artenvielfalt.",
    image: "https://images.unsplash.com/photo-1535940360221-641a69c43bac?crop=entropy&cs=srgb&fm=jpg&q=85",
    raised: 10450.0,
    goal: 95000.0
  },
  {
    id: "6",
    name: "Südamerika",
    location: "Amazon Regenwald",
    size: "5'200 Hektar",
    status: "In Planung",
    description: "Rettung des Amazon-Regenwaldes - Zuhause für Affen, Jaguare, bunte Tukane, Faultiere und tausende Insektenarten.",
    image: "https://images.unsplash.com/photo-1591081658714-f576fb7ea3ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxhbWF6b24lMjByYWluZm9yZXN0fGVufDB8fHx8MTc2Mjk2Mzg4OXww&ixlib=rb-4.1.0&q=85",
    raised: 1200.0,
    goal: 120000.0
  },
  {
    id: "7",
    name: "Australien",
    location: "Eukalyptus-Wälder",
    size: "3'800 Hektar",
    status: "In Planung",
    description: "Schutz australischer Eukalyptus-Wälder - Lebensraum für Koalas, Kängurus, Wombats, bunte Papageien und einzigartige Beuteltiere.",
    image: "https://images.unsplash.com/photo-1509414556967-312906f278a0?crop=entropy&cs=srgb&fm=jpg&q=85",
    raised: 0.0,
    goal: 110000.0
  },
  {
    id: "8",
    name: "Europa",
    location: "Verschiedene Länder",
    size: "3'500 Hektar",
    status: "Aktiv",
    description: "Schutz von europäischen Mischwäldern mit jahrhundertealten Buchen, Eichen und Tannen. Lebensraum für Rehe, Luchse, Füchse und unzählige Vogelarten.",
    image: "https://images.unsplash.com/photo-1735857999392-92e8bbab6c2c?crop=entropy&cs=srgb&fm=jpg&q=85",
    raised: 5000.0,
    goal: 100000.0
  }
];
